import { createRootRoute, Outlet, redirect } from '@tanstack/react-router'
import { WindowsSizeIndicator } from '~/components/shared/WindowsSizeIndicator'
import { decodeJwt } from '~/utils/utils'

export const Route = createRootRoute({
	beforeLoad: ({ location }) => {
		const pathname = location.pathname
		if (pathname === '/session-expired' || pathname === '/no-token' || pathname === '/maintenance') return

		const token = localStorage.getItem('token')
		if (token == null || token.length === 0) {
			redirect({ to: '/no-token', throw: true })
		}

		const jwt = decodeJwt(token)
		if (jwt.payload.exp < Date.now() / 1000) {
			redirect({ to: '/session-expired', throw: true })
		}
	},
	component: Root,
})

function Root() {
	return (
		<>
			<Outlet />
			{import.meta.env.DEV && <WindowsSizeIndicator />}
		</>
	)
}
